import React from 'react';
import {NavLink} from "react-router-dom";
import Notice from "./components/notice";
import '../../../assets/css/adminPages/home/notices.scss';
import useNotices from "../../../hooks/public/useNotices";

const Notices = () => {
    const {data} = useNotices();

    return (
        <section className="notice-section">
            <div className="custom-container">
                <header className="notice-header">
                    <h1 className="notice-section-title">Notice</h1>
                </header>
                <div className="notice-body">
                    {data && data.map((notice) => <Notice key={notice.id} notice={notice}/>)}
                </div>
            </div>
            <div className='notices-update-btn-container'>
                <NavLink className='add-btn' to='/admin/home/notices'>
                    update notices
                    <i className='fa fa-upload ml-2'></i>
                </NavLink>
            </div>
        </section>
    );
};

export default Notices;
